module.exports = __webpack_public_path__ + "static/img/online-service.6c12ab74.png";